import React, { useEffect, useState } from "react";
import {
  CreateBase,
  SimpleForm,
  TextInput,
  AutocompleteInput,
  useNotify,
  useRedirect,
  useCreate,
  useDataProvider,
} from "react-admin";
import Box from "@mui/material/Box";

const MenuCreate: React.FC = () => {
  const dataProvider = useDataProvider();

  const [parentMenus, setParentMenus] = useState<any[]>([]);
  const [actions, setActions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const notify = useNotify();
  const redirect = useRedirect();
  const [create] = useCreate();

  useEffect(() => {
  setLoading(true); // 确保每次刷新都显示 loading
  dataProvider
    .getList("permissionMenus/roots", {
      pagination: { page: 1, perPage: 10000 },
      sort: { field: "id", order: "ASC" },
      filter: {},
    })
    .then(({ data }) => {
      // 即使 data 为空，也加上顶级菜单
      setParentMenus([
        { id: null, title: "顶级菜单" },
        ...(Array.isArray(data) ? data : []),
      ]);
    })
    .catch(() => {
      // 接口失败，也保留顶级菜单
      setParentMenus([{ id: null, title: "顶级菜单" }]);
    })
    .finally(() => setLoading(false));
}, [dataProvider]);



  if (loading) return <span>Loading...</span>;

  const handleSave = async (data: any) => {
    // try {
    //   await create("menus", { data });
    //   notify("Menu Created", { type: "info" });
    //   redirect("list", "menus");
    // } catch (error) {
    //   notify("Create Failed", { type: "error" });
    // }
    // helper: make a slug but keep inner slashes if user supplied subpaths
    const slug = (s: string) =>
     s
       .toString()
        .trim()
        .replace(/^\//, '')
        .replace(/\s+/g, '-')
        .toLowerCase();

    const normalizePath = (p: string) => {
      if (!p) return '';
     let res = p.trim();
      if (!res.startsWith('/')) res = '/' + res;
     return res.replace(/\/+/g, '/');
    };

    try {
      const parentId = data.parentId;
      const rawPath = data.path ?? data.title ?? '';

      let finalPath = '';

      // no parent -> use current path (normalized). If user provided an absolute path it will be normalized;
      // otherwise slug the value.
      if (parentId === null || parentId === undefined) {
        const cur = rawPath || data.title || '';
        finalPath = normalizePath(cur.startsWith('/') ? cur : '/' + slug(cur));
      } else {
        // find parent in loaded parentMenus
        const parent = parentMenus.find((m) => String(m.id) === String(parentId));
        // prefer parent's path if present, otherwise derive from parent's title
        let parentPath = parent?.path ?? (parent?.title ? '/' + slug(parent.title) : '');
        parentPath = parentPath ? parentPath.replace(/\/$/, '') : '';

       // for current, take rawPath but remove leading slash and slug it (preserve inner slashes)
        const curSegment = slug(rawPath || data.title || '');
        finalPath = normalizePath(parentPath + '/' + curSegment);
      }

      const payload = { ...data, path: finalPath };
      await create("permissionMenus", { data: payload });
      notify("Menu Created", { type: "info" });
      redirect("list", "permissionMenus");
    } catch (error) {
      notify("Create Failed", { type: "error" });
    }
  };

  return (
    <CreateBase resource="permissionMenus">
      <SimpleForm sx={{ backgroundColor: "#ffffff", p: 3 }} onSubmit={handleSave}>
        <Box display="flex" flexWrap="wrap" gap={2}>
          <Box flex="1 1 48%">
            <TextInput source="title" label="Menu Title" required fullWidth />
          </Box>

          <Box flex="1 1 48%" sx={{height: 50}}>
            <TextInput source="path" label="Path (/xxx)" fullWidth />
          </Box>

          <Box flex="1 1 48%">
            <AutocompleteInput
              source="parentId"
              label="Parent Menu"
              choices={parentMenus}
              optionText="title"
              optionValue="id"
              fullWidth sx={{
                    flex: '1 1 48%',
                    '& .MuiAutocomplete-inputRoot': {
                      minHeight: '50px',
                      height: '50px',
                    },
                    '& .MuiOutlinedInput-input': {
                      height: '50px',
                      padding: '0 12px',
                      boxSizing: 'border-box',
                    },
                    '& .MuiAutocomplete-input': {
                      height: '50px',
                    },
                  }}
            />
          </Box>

       

          <Box flex="1 1 48%">
            <TextInput source="icon" label="Icon (Optional)" fullWidth />
          </Box>

          {/* <Box flex="1 1 48%">
            <TextInput source="order" label="Order" fullWidth />
          </Box> */}
        </Box>
      </SimpleForm>
    </CreateBase>
  );
};

export default MenuCreate;
